// extracted by mini-css-extract-plugin
export default {"popular_product_container":"PopularProductList_popular_product_container__UMiPz"};